enum ShowGameDay {
  First = "First",
  Current = "Current",
  Last = "Last",
}

export default ShowGameDay;
